import { api } from "@/api";
import { Sport } from "@/types/ApiResponses/Sport";
import { QueryProps } from "@/types/Api";

export interface GetSportsNewParams {
  category?: string;
  name?: string;
  lang?: string;
  popular?: boolean;
  mostPopular?: boolean;
  isProvider?: boolean;
  isTranslated?: boolean;
  active?: boolean;
  includeProviderIds?: boolean;
  includeSuspended?: boolean;
}

export const getSportsNew = async (
  props: QueryProps<GetSportsNewParams>
): Promise<Sport[]> => {
  const res = await api.client.get(`/sports-new`, {
    signal: props.signal,
    params: props.params,
  });
  return res.data;
};
